import { SVGProps, Ref, forwardRef } from 'react';

export const CardLinesOutlinedSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path d="M4 4.634v1.4h8v-1.4z" fill="currentColor" />
            <path d="M4 8.7h4V7.3H4z" fill="currentColor" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8 1C1.438 1 .5 1.875.5 8s.938 7 7.5 7 7.5-.875 7.5-7-.937-7-7.5-7M2.121 4.6C1.961 5.395 1.9 6.48 1.9 8s.06 2.604.221 3.4c.157.777.384 1.15.623 1.373.25.234.683.462 1.558.616.882.155 2.067.211 3.698.211s2.816-.056 3.698-.211c.875-.154 1.307-.382 1.558-.616.24-.223.466-.596.623-1.372.16-.797.221-1.881.221-3.401s-.06-2.604-.221-3.4c-.157-.777-.384-1.15-.623-1.373-.25-.234-.683-.462-1.558-.616C10.816 2.456 9.631 2.4 8 2.4s-2.816.056-3.698.211c-.875.154-1.307.382-1.558.616-.24.223-.466.596-.623 1.372"
                fill="currentColor"
            />
        </g>
    </svg>
));
CardLinesOutlinedSize16Glyph.displayName = 'CardLinesOutlinedSize16Glyph';
